import * as ScrollAreaPrimitive from '@radix-ui/react-scroll-area';

import { tv } from '@/utils/styles';

interface Props extends ScrollAreaPrimitive.ScrollAreaProps {
  orientation?: 'horizontal' | 'vertical';
}

const ScrollArea = ({ children, type, orientation = 'vertical', ...props }: Props) => {
  const { viewport, scrollbar, thumb, corner, thumbTarget } = styles({ orientation });

  return (
    <ScrollAreaPrimitive.Root type={type} {...props}>
      <ScrollAreaPrimitive.Viewport className={viewport()}>{children}</ScrollAreaPrimitive.Viewport>

      <ScrollAreaPrimitive.Scrollbar orientation={orientation} className={scrollbar()}>
        <ScrollAreaPrimitive.Thumb className={thumb()}>
          <span className={thumbTarget()} />
        </ScrollAreaPrimitive.Thumb>
      </ScrollAreaPrimitive.Scrollbar>

      <ScrollAreaPrimitive.Corner className={corner()} />
    </ScrollAreaPrimitive.Root>
  );
};

const styles = tv({
  slots: {
    viewport: 'h-full w-full',
    corner: 'bg-grey-600',
    thumb: 'relative flex-1 rounded-[10px] bg-grey-400',
    scrollbar:
      'duration-160 flex touch-none select-none rounded-[10px] bg-grey-200 transition-colors ease-out hover:bg-grey-300 data-[orientation=horizontal]:h-2 data-[orientation=vertical]:w-2 data-[orientation=horizontal]:flex-col',
    thumbTarget: 'absolute left-1/2 top-1/2 min-h-11 min-w-11 -translate-x-1/2 -translate-y-1/2',
  },
  variants: {
    orientation: {
      horizontal: {
        thumb: 'min-h-2',
      },
      vertical: {
        thumb: 'min-w-2',
      },
    },
  },
});

export { ScrollArea };
